import { Component, OnInit, NgZone, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { ConstantsService } from "../services/constants.service";
import { CacheService } from '../services/cache.service';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';
import { Location } from '@angular/common';
// import { HelperService } from '../services/helper.service';



@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit, OnDestroy {

  isPrime: any;
  login: boolean;
  @ViewChild('targetDiv', { static: false }) targetDiv: ElementRef;
  constructor(
    public constants: ConstantsService,
    private authenticate: CacheService,
    private userService: UserService,
    private router: Router,
    private mixpanel: SharedMixpanelService,
    private zone: NgZone,
    private _location: Location,
    // private helperService:HelperService

  ) { }

  ngOnInit(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
    this.authcall();
  }

  ngOnDestroy(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
  }

  public async authcall() {
    this.authenticate.getAuthUser()
      .then(async (data) => {
        let { login } = data;
        this.login = login;
        if (login) {
          await this.userService.getUser(true).then(async data => {
            let { isPrime } = data;
            this.isPrime = isPrime === undefined ? true : isPrime;
          })
        }
        else {
          this.isPrime = false
        }
      })
  }

  Takemetoprime() {
    if (!this.login) {
      this.router.navigate(['/signup']);
      localStorage['fromwindowBookmark'] = JSON.stringify(true);
      localStorage['fromwindowBookmark-CurrentVideo'] = JSON.stringify([this.authenticate.get()]);
    }
    else {
      this.router.navigate(['/pricing']);
    }
  }

  async logout() {
    try {
      await await Auth.signOut()
      this.userService.userData = undefined;
      this.userService.isFirstCall = true;
      this.zone.run(() => this.router.navigate(['/login']));
    } catch (error) {
      if (error.code === 'NotAuthorizedException') {
        console.error('Access Token has been revoked. Please log in again.');
        localStorage.clear();
        // Optionally redirect to login or show a message to the user
        this.router.navigate(['/login']);
      } else {
        console.error('Error signing out:', error);
      }
    }
  }

  hasId(content: any): string {
    if(content.id != undefined){
      return content.id;
    }else {
      return ''
    }
  }

  scrollToDiv(id: string): void {
    console.log(id);
    const element = this.targetDiv.nativeElement.querySelector(`#${id}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

  OnClickClose = () => {
    this._location.back();
  }
}
